import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
// import { useNavigate } from 'react-router-dom';
import { isPermission, isRole } from '../../redux/selectors/authSelector';
import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';
// import { message } from '../../redux/actions/toastActions';
import DeleteModal from '../common/DeleteModal';
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import ModalPopup from '../common/Modal';
import crossIcon from "../../assets/Icons/cross.svg";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import Loader from '../common/Loader';
import { Toaster, toast } from 'sonner'

const CmsList = () => {
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [data, setData] = useState([]);
    const [loader, setLoader] = useState(false);
    // const dispatch = useDispatch();
    // const navigate = useNavigate();
    const menuRefs = useRef([]);
    const [refresh, setRefresh] = useState(false);
    const [modalOpenDelete, setmodalOpenDelete] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false)
    const permissions = useSelector(isPermission);
    const role = useSelector(isRole)
    console.log("permissions", permissions)
    const addPermission = role == "schooladmin"
    const deletePermission = role == "schooladmin"
    const [modalswitch, setmodalswitch] = useState(false);
    const [formData, setFormData] = useState({ title: "", text: "" });
    const [errors, setErrors] = useState({});

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const toggleMenu = (index) => {
        setOpenMenuIndex(openMenuIndex === index ? null : index);
        // setOpenMenuIndex(true);
    };

    const validateForm = () => {
        const newErrors = {};
        if (!formData.title.trim()) newErrors.title = "Title is required";
        if (!formData.slug.trim()) newErrors.slug = "Slug is required";
        else if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(formData.slug.trim()))
            newErrors.slug = "Slug must be URL-friendly (lowercase, hyphens only)";
        if (!formData.text.trim()) newErrors.text = "Content is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleDelete = (id) => {
        setLoader(true)
        Postdata(HttpService.school_cms_delete, { id: id }).then((res) => {
            if (res.status === 200) {
                toast.success('Policies Deleted Successfully');
                setRefresh(!refresh);
            }
            // else {

            //     dispatch(message(res.message));
            // }
        });
        setLoader(false)
        setOpenMenuIndex(null);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoader(true);

        const payload = new FormData();
        payload.append("title", formData.title);
        payload.append("slug", formData.slug);
        payload.append("text", formData.text);
        if (formData.id) payload.append("id", formData.id);

        Postdata(HttpService.school_cms_add, payload).then((res) => {
            console.log('res:::::::::: ', res);
            if (res.status === 200) {
                setmodalswitch(false);
                setFormData({ title: "", slug: "", text: "" });
                setRefresh(!refresh);
                toast.success(res.message);
            }
            else {
                toast.warning(res.message)
            }
            // dispatch(message(res.message));
        });
        setLoader(false);
    };

    const fetchData = () => {
        setLoader(true);
        Postdata(HttpService.school_cms_list).then((res) => {
            if (res.status === 200) {
                setData(res.data);
            }
            // else{
            //     dispatch(message(res.message));
            // }
        });
        setLoader(false)
    }

    useEffect(() => {
        fetchData();
    }, [refresh])

    useEffect(() => {
        if (!modalswitch) {
            setFormData({ title: "", slug: "", text: "" });
            setErrors({});
        }
    }, [modalswitch]);

    // Close menu on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
            let clickedInside = false;
            menuRefs.current.forEach(ref => {
                if (ref && ref.contains(event.target)) {
                    clickedInside = true;
                }
            });
            if (!clickedInside) {
                setOpenMenuIndex(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    // if (loader) {
    //     return <Loader isClass="loader_fullscreen" />
    // }

    return (
        <>
            <ModalPopup
                className="alert-box-popup"
                show={modalswitch}
                size="lg"
                onHide={() => { setmodalswitch(false); setFormData({ title: "", slug: "", text: "" }); }}
                heading="Are you sure?"
            >
                <div className="text-start flex justify-center flex-col items-center gap-3 px-3 relative ">
                    <img
                        src={crossIcon}
                        alt=""
                        className="absolute top-2 right-2 cursor-pointer"
                        onClick={() => {
                            setFormData({ title: "", slug: "", text: "" });
                            setmodalswitch(false);
                            // setRefresh(!refresh)
                        }}
                    />
                    <h3> CMS Page</h3>

                    <form className="w-full" onSubmit={handleSubmit}>
                        <div>
                            <label className="block mb-1 font-medium text-gray-700">
                                Title <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="title"
                                placeholder="Enter Title Of Page"
                                className="input-field border"
                                value={formData.title}
                                onChange={handleInputChange}
                                min={1}
                                max={50}
                            />
                            {errors.title && (
                                <span className="text-red-500 text-sm">Required</span>
                            )}
                        </div>
                        <div>
                            <label className="block mb-1 font-medium text-gray-700">
                                Slug <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="slug"
                                placeholder="Enter Slug (e.g., my-page-title)"
                                className="input-field border"
                                value={formData.slug}
                                onChange={handleInputChange}
                            />
                            {errors.slug && (
                                <span className="text-red-500 text-sm">{errors.slug}</span>
                            )}
                        </div>
                        <div className="w-full  gap-3 mb-2 mt-4">
                            <div className="w-full mb-2">

                                <CKEditor
                                    editor={ClassicEditor}
                                    data={formData.text}
                                    config={{
                                        placeholder: 'Write Here'
                                    }}
                                    onChange={(event, editor) => {
                                        setFormData({ ...formData, text: editor.getData() });
                                    }}
                                />
                                {errors.text && (
                                    <span className="text-red-500 text-sm">{errors.text}</span>
                                )}
                            </div>


                        </div>
                        <div className='flex justify-center w-full '>
                            <button
                                type="button"
                                className="bg-[#BF360C] text-white px-16 py-2 font-medium rounded-lg m-2  flex justify-center"
                                style={{ width: "30%" }}
                                onClick={() => {
                                    setFormData({ title: "", slug: "", text: "" });
                                    setmodalswitch(false);
                                    // setRefresh(!refresh)
                                }}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="bg-primary_main text-white px-16 py-2.5 rounded-lg font-medium hover:bg-purple-700 m-2  flex justify-center"
                                style={{ width: "30%" }}
                            >
                                {loader ? "Saving..." : "Save"}
                            </button>
                        </div>
                    </form>

                </div>
            </ModalPopup>
            <div className='flex justify-end'>
                <button
                    className={`${"button-small-primary"}`}
                    onClick={() => setmodalswitch(true)}
                >
                    + Add Page
                </button>
            </div>
            {data.length > 0 && data.map((item, index) =>
            (
                <div className="bg-white rounded-lg p-6 shadow-md relative text-gray-800   mx-auto">
                    <div>
                        <h2 className="text-2xl font-semibold mb-2">
                            {item.title}
                        </h2>

                        <div className="text-sm mb-4">
                            <span>/{item.slug}</span>
                        </div>
                        <div>
                            <div dangerouslySetInnerHTML={{ __html: item.text }} />
                        </div>
                    </div>
                    {(addPermission || deletePermission) && <div className='bg-white '>
                        <div className="absolute top-3 right-3">
                            <button onClick={() => toggleMenu(index)}>
                                <img
                                    src={HiOutlineDotsVertical}
                                    className="text-black-500 hover:text-black"
                                />
                            </button>

                            {openMenuIndex == index && (
                                <div ref={(el) => (menuRefs.current[index] = el)} className="absolute right-0 w-20 bg-white shadow-md border rounded-xl z-10">
                                    {addPermission && <button
                                        className="block w-full text-left px-3 rounded-t-xl py-2 text-sm hover:bg-gray-100"
                                        onClick={() => { setmodalswitch(true); setFormData({ title: item.title, slug: item.slug, text: item.text, id: item._id }) }}
                                    >
                                        Edit
                                    </button>}
                                    {deletePermission && <button
                                        onClick={() => {
                                            setSelectedId(item._id);
                                            setmodalOpenDelete(true);
                                        }}
                                        className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                                    >
                                        Delete
                                    </button>}
                                </div>
                            )}
                        </div>

                    </div>}
                </div>
            )
            )}
            <DeleteModal
                title="Delete Page"
                message="Are you sure you want to delete Page?
It will erase all the data permanently."
                modalOpenDelete={modalOpenDelete}
                setmodalOpenDelete={setmodalOpenDelete}
                handleDelete={handleDelete} // Don't call it here
                selectedId={selectedId}
                setSelectedId={setSelectedId}
                modalOpenDeleteSuccess={modalOpenDeleteSuccess}
                setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
                redirectPage={"Settings"}
                redirectUrl={"settings"}
                module={"Page"}
            />
            {
                !(data.length > 0) && <div className="h-[50vh] flex items-center justify-center w-full">
                    <h1 className="text-center text-gray-400">No Data Found</h1>
                </div>
            }
        </>
    )
}

export default CmsList